(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alteire-cookie-banner"] && !Shopify.designMode) return;
  try {
    (() => {
    const copyElement = document.getElementById('alteire-cookie-banner-copy');
    if (!copyElement) return;

    let copy;
    try {
      copy = JSON.parse(copyElement.textContent);
    } catch {
      return;
    }

    const applyBannerCopy = () => {
      const banner = document.getElementById('shopify-pc__banner');
      if (!banner || banner.dataset.alteireCopy === 'ready') return;

      const paragraph = banner.querySelector('.shopify-pc__banner__body p');
      const policyLink = banner.querySelector('#shopify-pc__banner__body-policy-link');
      const preferences = banner.querySelector('#shopify-pc__banner__btn-manage-prefs');
      const accept = banner.querySelector('#shopify-pc__banner__btn-accept');
      if (!paragraph || !policyLink || !preferences || !accept) return;

      banner.dataset.alteireCopy = 'ready';
      policyLink.textContent = copy.read_more;
      paragraph.replaceChildren(document.createTextNode(copy.text + ' '), policyLink);
      const preferencesLabel = preferences.querySelector('span') || preferences;
      preferencesLabel.textContent = copy.preferences;
      accept.textContent = copy.accept;
    };

    applyBannerCopy();

    const observer = new MutationObserver((records) => {
      const bannerAdded = records.some((record) => Array.from(record.addedNodes).some((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return false;
        return node.id === 'shopify-pc__banner' ||
          node.closest('#shopify-pc__banner') ||
          node.querySelector('#shopify-pc__banner');
      }));
      if (bannerAdded) applyBannerCopy();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
